export var estimatedCostListTourSteps = [
    {
        element: 'button.c-project-header__progress-btn.c-project-header__progress-btn--construction',
        popover: {
            title: '「新規作成」ボタンで見込み原価を登録できます',
            side: 'bottom'
        },
        autoAdvanceTrigger: 'button-click'
    },
    {
        element: 'body > main:nth-child(3) > div:nth-child(3) > div:nth-child(1) > div:nth-child(1) > div:nth-child(2) > div:nth-child(1) > div:nth-child(1) > form:nth-child(1) > label:nth-child(2)',
        popover: {
            title: '「ファイルをOCR読み込み」をクリックしてPDFを選択すると、金額・品目を自動入力できます',
            side: 'bottom'
        },
        autoAdvanceTrigger: 'file-selected'
    },
    {
        element: 'div.c-table-content',
        popover: {
            title: 'アップロード後、ステータスが「未登録」になった書類をクリックしてください。次のページに遷移したら「見込み原価フォームツアー」を起動してください。',
            side: 'top'
        }
    }
];
